module.exports = __webpack_public_path__ + "fonts/share.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/svgs/share.svg
// module id = 605
// module chunks = 5